import { render, staticRenderFns } from "./QType1GroupList.vue?vue&type=template&id=3bebb460&scoped=true&"
import script from "./QType1GroupList.vue?vue&type=script&lang=js&"
export * from "./QType1GroupList.vue?vue&type=script&lang=js&"
import style0 from "./QType1GroupList.vue?vue&type=style&index=0&id=3bebb460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bebb460",
  null
  
)

export default component.exports